module.exports = __webpack_public_path__ + "static/media/Text.cfd94ec2.svg";